import { EventDetailDto, EventSummaryDto } from "@aoe/client";
import { createReducer, on } from "@ngrx/store";
import { eventActions } from "./event.actions";

export interface EventState {
    events: EventSummaryDto[];
    nb: number;
    loading: boolean;
    error?: any;
    warning?: any;
    info?: any;
    selectedEventId: string | null;
    selectedEventDetail: EventDetailDto | null;
}

export const initialeState: EventState = {
    events: [],
    nb: 0,
    loading: false, // 💡 Initialisé à false par défaut
    selectedEventDetail: null,
    selectedEventId: null
};

export const eventReducer = createReducer(
    initialeState,
    // Passage à loading: true sur le chargement global ET par ID
    on(
        eventActions.loadEvent,
        eventActions.loadEventById,
        state => ({
            ...state,
            loading: true,
            error: null
        })
    ),
    on(
        eventActions.loadSuccess, (state, res) => ({
            ...state,
            loading: false,
            events: res.data?.events ?? [],
            nb: res.data?.nb ?? 0,
            info: res.info,
            warning: res.warning,
        })
    ),
    on(
        eventActions.loadFailed, (state, res) => ({
            ...state,
            loading: false,
            error: res.error
        })
    ),
    on(
        eventActions.loadSuccessById, (state, res) => ({
            ...state,
            loading: false,
            info: res.info,
            warning: res.warning,
            selectedEventDetail: res.data ?? null,
            selectedEventId: res.data ? res.data.id : null
        })
    ),
    on(
        eventActions.loadFailedById, (state, res) => ({
            ...state,
            loading: false,
            error: res.error
        })
    ),
    on(
        eventActions.resetSleectedEvent, state => ({
            ...state,
            selectedEventDetail: null,
            selectedEventId: null
        })
    )
);